import { render, staticRenderFns } from "./CampDocs.vue?vue&type=template&id=b546d586&lang=pug&"
import script from "./CampDocs.vue?vue&type=script&lang=js&"
export * from "./CampDocs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports